var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavEsgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.33333 13.3333C6.16271 13.3369 5.0335 12.9003 4.16968 12.1103C3.30585 11.3202 2.77051 10.2344 2.66982 9.06807C2.56914 7.90178 2.91046 6.74024 3.6261 5.81383C4.34174 4.88742 5.37942 4.2638 6.53333 4.06667C10.3333 3.33333 11.3333 2.98667 12.6667 1.33333C13.3333 2.66667 14 4.12 14 6.66667C14 10.3333 10.8133 13.3333 7.33333 13.3333Z",
    stroke: "#525252",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.33333 14C1.33333 12 2.56667 10.4267 4.72 10C6.33333 9.68 8 8.66667 8.66667 8",
    stroke: "#525252",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavEsgIcon);
export default __webpack_public_path__ + "static/media/nav-esg-icon.485078111285dda647234547c2eabbd1.svg";
export { ForwardRef as ReactComponent };